import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "results-panel" }
const _hoisted_2 = { class: "results-panel__header-left" }
const _hoisted_3 = { class: "results-panel__header-right" }
const _hoisted_4 = { class: "results-panel__no-matching__wrapper" }
const _hoisted_5 = { class: "results-panel__no-matching__badges" }
const _hoisted_6 = { class: "results-panel__note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxEmptyMessage = _resolveComponent("PxEmptyMessage")!
  const _component_PxStatusBadge = _resolveComponent("PxStatusBadge")!
  const _component_CapitalTile = _resolveComponent("CapitalTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'results-panel__header--scroll': !_ctx.scrollAtTop }, "results-panel__header"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("capitalExplorer.resultsPanel.title")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PxButton, _mergeProps(_ctx.glossaryButtonProps, {
          ref: "glossaryButton",
          class: "results-panel__glossary-button",
          onClick: _ctx.onGlossaryClick
        }), null, 16, ["onClick"]),
        _createVNode(_component_PxButton, _mergeProps({
          ref: "compareButton",
          class: "results-panel__compare-button"
        }, _ctx.compareButtonProps, { onClick: _ctx.onCompareButtonClick }), null, 16, ["onClick"])
      ])
    ], 2),
    _createElementVNode("div", {
      ref: "panel",
      class: "results-panel__wrapper",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkScroll && _ctx.checkScroll(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{ visible: _ctx.noMatchingData }, "results-panel__no-matching"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_PxEmptyMessage, {
            "icon-size": 92,
            subtitle: _ctx.emptySubtitle,
            "subtitle-size": 15,
            title: _ctx.emptyTitle,
            "title-size": 17,
            icon: "matching-no-matches",
            "subtitle-style": "none"
          }, null, 8, ["subtitle", "title"]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchingBadges, (badge, index) => {
              return (_openBlock(), _createBlock(_component_PxStatusBadge, {
                key: index,
                "background-color": badge.backgroundColor,
                "border-color": badge.borderColor,
                icon: badge.icon,
                "icon-size": 13,
                label: _ctx.$t(badge.title),
                "label-color": badge.textColor,
                "label-size": 14,
                style: _normalizeStyle({ boxShadow: badge.boxShadow }),
                uppercase: false,
                weight: 600
              }, null, 8, ["background-color", "border-color", "icon", "label", "label-color", "style"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("capitalExplorer.resultsPanel.noMatchingData.note")), 1)
          ])
        ])
      ], 2),
      _createVNode(_TransitionGroup, {
        class: _normalizeClass([{
          'results-panel__results--no-matching': _ctx.noMatchingData,
        }, "results-panel__results"]),
        name: "flip-tiles",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
            return (_openBlock(), _createBlock(_component_CapitalTile, {
              key: result.capitalInfo.id,
              "capital-info": result.capitalInfo,
              "match-details": result.matchDetails,
              "match-properties": result.matchProperties,
              "show-matching-badge": _ctx.showMatchingBadge
            }, null, 8, ["capital-info", "match-details", "match-properties", "show-matching-badge"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["class"])
    ], 544),
    _createVNode(_component_PxStatusBadge, _mergeProps({ class: "results-panel__floating-tag" }, _ctx.floatingTagProps), {
      additionalContent: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("a", {
          href: "https://www.adventure.finance/",
          target: "_blank"
        }, " Aunnie Patton Power ", -1),
        _createElementVNode("span", null, "🤝", -1)
      ]))]),
      _: 1
    }, 16)
  ]))
}